export default function getProxyValidationConfig(FormValidator, translations, settings, formData, maxLinesReached, deliveryLeadTime, fulfillmentType) {

  if (!translations || !settings || !formData) {
    return {};
  }

  const config = {
    card_delivery: [
      {
        name: "properties._gcp_fulfillment_type",
        test: (value) => { return FormValidator.constraints.hasValue(value) },
        error_message: translations.errors.please_select_delivery,
      },
    ],
    greeting_card: [
      {
        name: "properties._gcp_selected_card_image",
        test: (value) => { return FormValidator.constraints.hasValue(value) && FormValidator.constraints.isString(value) },
        error_message: translations.errors.please_select_card_image,
      }
    ],
    gift_card: [
      {
        name: "id",
        test: (value) => {
          if (value === "Custom") return true;
          if (settings?.global?.appearance?.form_theme === "product_template") return true; // Theme controls variant selection
          const variantIds = Array.isArray(settings?.product?.variants) ? settings.product.variants.map((variant) => variant.id) : [];
          return FormValidator.constraints.hasValue(value) && FormValidator.constraints.isMemberOf(value, variantIds);
        },
        error_message: translations.errors.please_select_card_value,
      }
    ],
    gift_message: [],
  };

  if (formData.id === "Custom") {
    config.gift_card.push({
      name: "properties._gcp_custom_value",
      test: (value) => {
        return FormValidator.constraints.hasValue(value) &&
               FormValidator.constraints.isGreaterThanOrEqualTo(value, settings.digital.giftcard.custom_min_price) &&
               FormValidator.constraints.isLessThanOrEqualTo(value, settings.digital.giftcard.custom_max_price)
      },
      error_message: translations.errors.custom_value_error_message
                     .replace("{min}", settings.digital.giftcard.custom_min_price)
                     .replace("{max}", settings.digital.giftcard.custom_max_price),
    });
  }

  if (fulfillmentType === "digital") {
    config.gift_card.push({
      name: "properties._gcp_recipient_email",
      test: (value) => { return FormValidator.constraints.hasValue(value) && FormValidator.constraints.isEmail(value) },
      error_message: translations.errors.invalid_email_error_message,
    });
  } 
  
  if (fulfillmentType === "physical") {
    config.gift_card.push(
      {
        name: "properties._gcp_address.firstName",
        test: (value) => { return FormValidator.constraints.hasValue(value) && FormValidator.constraints.isString(value) },
        error_message: translations.errors.invalid_first_name_error_message,
      },
      {
        name: "properties._gcp_address.lastName",
        test: (value) => { return FormValidator.constraints.hasValue(value) && FormValidator.constraints.isString(value) },
        error_message: translations.errors.invalid_last_name_error_message,
      },
      {
        name: "properties._gcp_address.address1",
        test: (value) => { return FormValidator.constraints.hasValue(value) && FormValidator.constraints.isString(value) },
        error_message: translations.errors.invalid_address_error_message,
      },
      {
        name: "properties._gcp_address.city",
        test: (value) => { return FormValidator.constraints.hasValue(value) && FormValidator.constraints.isString(value) },
        error_message: translations.errors.invalid_city_error_message,
      },
      {
        name: "properties._gcp_address.country",
        test: (value) => { return FormValidator.constraints.hasCountryValue(value) },
        error_message: translations.errors.invalid_country_error_message,
      },
      {
        name: "properties._gcp_address.zip",
        test: (value) => { return FormValidator.constraints.hasValue(value) && FormValidator.constraints.isString(value) },
        error_message: translations.errors.invalid_zip_error_message,
      },
      {
        name: "properties._gcp_address.phone",
        test: (value) => { return !FormValidator.constraints.hasValue(value) || FormValidator.constraints.isEqualTo(value, "+") || FormValidator.constraints.isPhone(value) },
        error_message: translations.errors.invalid_phone_error_message,
      },
      {
        name: "properties._gcp_formatted_address",
        test: (value) => { return FormValidator.constraints.hasValue(value) && FormValidator.constraints.isString(value) },
        error_message: translations.errors.invalid_formatted_address_error_message,
      }
    );

    if (settings.physical?.appearance?.shipping_terms_banner === "visible_with_checkbox") {
      config.gift_message.push(
        {
          name: "_gcp_shipping_terms_accepted",
          test: (value) => { return FormValidator.constraints.hasValue(value) && FormValidator.constraints.isEqualTo(value, "1") },
          error_message: translations.errors.please_accept_shipping_terms,
        }
      );
    }
  }

  if (!formData.properties._gcp_send_to_self) {
    config.gift_card.push(
      {
        name: "properties._gcp_recipient_phone",
        test: (value) => { return !FormValidator.constraints.hasValue(value) || FormValidator.constraints.isEqualTo(value, "+")  || FormValidator.constraints.isPhone(value) },
        error_message: translations.errors.invalid_phone_error_message,
      },
      {
        name: "properties._gcp_recipient_name",
        test: (value) => { return FormValidator.constraints.hasValue(value) && FormValidator.constraints.isString(value) },
        error_message: translations.errors.invalid_recipient_error_message,
      },
    );

    if (formData.properties._gcp_delivery_time === "Send Later") {
      config.gift_card.push(
        {
          name: "properties._gcp_delivery_date",
          test: (value) => { return FormValidator.constraints.hasValue(value) && FormValidator.constraints.isString(value) },
          error_message: translations.errors.invalid_date_error_message,
        },
        {
          name: "properties._gcp_delivery_timezone",
          test: (value) => { return FormValidator.constraints.hasValue(value) && FormValidator.constraints.isString(value) },
          error_message: translations.errors.invalid_timezone_error_message,
        },
        {
          name: "properties._gcp_iso_delivery_date",
          test: (value) => { return FormValidator.constraints.hasValue(value) && FormValidator.constraints.isFutureDate(value, deliveryLeadTime) },
          error_message: translations.errors.invalid_delivery_date_error_message,
        },
      )
    }

    config.gift_message.push(
      {
        name: "properties._gcp_message_from",
        test: (value) => { return FormValidator.constraints.hasValue(value) && FormValidator.constraints.isString(value) },
        error_message: translations.errors.invalid_message_from_error,
      },
      {
        name: "properties._gcp_message_text",
        test: (value) => { return maxLinesReached === false && (!FormValidator.constraints.hasValue(value) || FormValidator.constraints.isString(value)) },
        error_message: translations.errors.invalid_message_text_error_message,
      },
    );
  }

  return config;

};
